export const isLocalhost = (): boolean => {
    return (
        window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) !== null
    );
};

export const isLocal = (): boolean => {
    if (isLocalhost()) return true;
    if (process.env.NODE_ENV === 'test') return true;
    return false;
};

export const isDev = (): boolean => {
    const hostname = window.location.hostname;
    if (hostname.includes('-dev')) return true;
    if (process.env.NODE_ENV === 'development') return true;
    return false;
};

export const isLocalOrDev = (): boolean => {
    return isLocal() || isDev();
};

//** si on est en debug, c'est à dire si la varaible d'environnement REACT_APP_MODE_DEBUG est à true */
export const SHOW_DEBUG = process.env.REACT_APP_MODE_DEBUG === 'true';

export const isAdmin = (agentCode: string): boolean => {
    const admins = process.env.REACT_APP_ADMIN_AGENT_CODE?.split(';');
    return admins ? admins.includes(agentCode) : false;
};
